<template>
<div class="section2 home" :class="{'m':isMobile()}">
      <div class="main">
          <a class="bigTitle">
              <h2>{{ moduleTitle }}</h2>
              <span>{{ moduleDesc }}</span>
          </a>
          <div class="conbox">
              <ul>
				  <template v-for="(item,index) in gameList" :key="index">
					  <li @click="toDetail(item)">
						  <div class="imgbox h156"><img :src="item.resourceLink" /></div>
						  <div class="desbox">
							  <h4>{{ item.title }}<span v-if="item.gameType" class="tag">{{ item.gameType }}</span></h4>
							  <!-- <p>{{ item.textDescription }}</p> -->
							  <div class="descDots line3" v-html="filterHTML(item.textDescription)"></div>
						  </div>
					  </li>
				  </template>
              </ul>
          </div>
      </div>
  </div>
</template>

<script setup>
	import { isMobile } from '@/utils/common.js'
	import { getPartDetail } from '@/api/index'
	import { ref, onMounted, reactive } from 'vue'
	import { useRouter } from 'vue-router'
	
	let router = useRouter();
	let moduleTitle = ref('游戏列表')
	let moduleDesc = ref('Game List')
	let gameList = ref([])//游戏11
	let queryParams = reactive({
		moduleId:11,
		isHomePageConf: 1,//首页显示
		ifPage: 1,
		pageNum: 1,
		pageSize: 3
	})
	onMounted(()=>{
		getPartDetail(queryParams).then((res)=>{
			gameList.value = res.rows;
			if(res.rows > 0){
				moduleTitle.value = res.rows[0].moduleName
				moduleDesc.value = res.rows[0].nameEnglish
			}
		})
	})
	
	const toDetail = (item) => {
		if(item.hyperLink){
			window.open(item.hyperLink)
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>

</style>
